/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_TrainingInputs */



/**
* | output |
* | --- |
* | "1:1 Team Training" |
*
* @param {Signup_Compare_TrainingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_training = /** @type {((inputs?: Signup_Compare_TrainingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_TrainingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "de") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "it") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "es") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1:1 Team Training")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("1:1 Team Training")
	return /** @type {LocalizedString} */ ("1:1 Team Training")
});